const ObjectManager = {
    delete: (arr, property, value) => {
        return arr.filter(item => (item?.[property] || item) !== value)
    },
    getLastElement: arr => {
        return arr[arr.length - 1]
    }
}

export const isValidJson = jsonString => {
    try {
        JSON.parse(jsonString)
        return true
    } catch (error) {
        return false
    }
}

export const areArraysEqual = (arr1 = [], arr2 = []) => {
    if (arr1?.length !== arr2?.length) return false
    return arr1.every(item => arr2.includes(item)) && arr2.every(item => arr1.includes(item))
}

export const getImageSource = async(image) => {
    const imageSrc = await import(`../assets/images/${image}`)
    return imageSrc.default || null
}

export const groupDataByProperty = (data, property) =>
    data?.reduce((acc, item) => {
        const key = property
            .split('.')
            .reduce((nested, prop) => nested?.[prop], item)

        if (!key) return acc
        if (!acc[key]) acc[key] = []
        acc[key].push(item)
        return acc
    }, {})

export default ObjectManager
